//namespace Pacem {
import { NullChecker } from "./null-checker";
export class Arrays {
    static range(min, max, items = 2) {
        let x = min;
        if (NullChecker.isNull(max)) {
            max = items = min;
            min = 1;
        }
        const step = (max - min) / (items - 1);
        const output = [];
        if (step > 0) {
            //while (x <= max) {
            while (output.length < items) {
                output.push(x.roundoff());
                x += step;
            }
        }
        return output;
    }
    static chunkify(source, size) {
        if (NullChecker.isNullOrEmpty(source)) {
            return [];
        }
        if (size <= 0 || size % 1 !== 0) {
            throw new Error('Provide a positive integer number.');
        }
        const length = Math.ceil(source.length / size);
        return Array.from({ length }, (_, index) => {
            const start = index * size, end = start + size;
            return source.slice(start, end);
        });
    }
}
//}
